import ChangeSitePasswordPage from './ChangeSitePasswordPage';

export * from './types';

export default ChangeSitePasswordPage;
